export const withDefaults = <T extends Record<string, any>>(
  values: T,
  defaults: Partial<T>,
): T => {
  const result = { ...values };
  for (const key in defaults) {
    if (result[key] == null) {
      // checks both null and undefined
      result[key] = defaults[key] as T[typeof key];
    }
  }
  return result;
};
